import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import EventsList from './EventsList'
import EventsCalendarPage from './EventsCalendarPage'

const eventsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Events',
    path: '/events/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const EventsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Events'}></DocumentTitle>
              <PageTitle breadcrumbs={eventsBreadcrumbs}>Events</PageTitle>
              <EventsList />
            </>
          }
        />
        <Route
          path='calendar'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Events Calendar'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={eventsBreadcrumbs}>Events Calendar</PageTitle>
              <EventsCalendarPage />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default EventsPage
